import React from 'react';
import { Box, Container, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: '6px 3.175%',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #ededed',
}));

export const HeaderLayout: React.FC<{ children: React.ReactNode }> = (
    props
) => {
    return (
        <>
            <StyledBox>{props.children}</StyledBox>
        </>
    );
};
